import { StateDataContext } from 'containers/Common/StateDataContext';
import {
  TrackEvent,
  ViewTrackingTrigger,
  ViewTrackingType
} from 'core/rtbCampaign/RtbCampaign';
import { useContext, useMemo } from 'react';
import { TrackingData } from 'core/rtbCampaign/TrackingData';
import { TrackingConfig } from 'containers/RtbCampaigns/RtbCampaignSetupFlow/RtbCampaignForm/RtbCampaignBasicFormModel';

export type ModifyTrackingStateContentModel = {
  defaultTrackingData: TrackingData;
  conversionTrackingOptions: SelectOptions[];
  conversionTrackingTypeOptions?: SelectOptions[];
  onDataChange: (newTrackingData: TrackingData) => void;
  getThirdPartyTrackingTypeOptions: () => {
    label: string;
    value: ViewTrackingType;
  }[];
  getThirdPartyTriggerTypeOptions: (trackingType: ViewTrackingType) => {
    label: string;
    value: ViewTrackingTrigger;
  }[];
};

export const useModifyTrackingStateContentModel = (
  needShowConversionTracking: boolean,
  trackingConfig: TrackingConfig
): ModifyTrackingStateContentModel => {
  const { data, setData } = useContext(StateDataContext);

  const defaultTrackingData: TrackingData = useMemo(() => {
    if (data) {
      return data;
    }

    return needShowConversionTracking
      ? {
          convTrackEvent: TrackEvent.CLICK
        }
      : {};
  }, [data, needShowConversionTracking]);

  const conversionTrackingOptions = useMemo(() => {
    return trackingConfig.conversionTracking.options || [];
  }, [trackingConfig]);

  return {
    defaultTrackingData,
    conversionTrackingOptions,
    conversionTrackingTypeOptions:
      trackingConfig.conversionTracking.conversionTrackingTypeOptions,
    onDataChange: setData,
    getThirdPartyTrackingTypeOptions:
      trackingConfig.getThirdPartyTrackingTypeOptions,
    getThirdPartyTriggerTypeOptions:
      trackingConfig.getThirdPartyTriggerTypeOptions
  };
};
